export const traducciones = {
    es: {
      icon: "∨",
      title: "QANTICO DEVS",
      location: "Colombia",
      city: "Oiba, Santander",
      address: "Carrera 9 11-32, Codigo Postal: 683021",
      design: "Hecho con ❤️",
      title2: '"Convertimos tus ideas en realidad"',
      developer: "www.qanticodevs.com",
      // Añade aquí más traducciones para toda la aplicación
    },
    en: {
      icon: "∨",
      title: "QANTICO DEVS",
      location: "Colombia",
      city: "Oiba, Santander",
      address: "Carrera 9 11-32, Zip Code: 683021",
      design: "Made with ❤️",
      title2: '"We make your ideas come true"',
      developer: "www.qanticodevs.com",
    }
  };